import * as React from 'react'
import loadable from '@loadable/component'

import CodeBlockInline from './code-block-inline'
import FallbackCodeBlock from './code-block-multiline/fallback'

// we cannot ssr here because this component relies on Monaco
// which is not available in the React-Renderer.
const CodeBlockMultiline = loadable(() => import('./code-block-multiline'), { ssr: false })

export interface CodeBlockProps {
    children: string
    inline?: boolean
    language?: string
    filename?: string
}

const CodeBlockAsync: React.FC<CodeBlockProps> = ({ inline, ...props }) => {
    return (
        <>
            {inline ? (
                <CodeBlockInline>{props.children}</CodeBlockInline>
            ) : (
                <CodeBlockMultiline {...props} fallback={<FallbackCodeBlock>{props.children}</FallbackCodeBlock>} />
            )}
        </>
    )
}

export default CodeBlockAsync
